const privacyRouter = {
  path: '',
  component: () => import('@/layout'),
  children: [
    {
      path: '/privacy_statement',
      name: 'PrivacyStatement',
      meta: { title: '隐私权声明及保护政策' },
      component: () => import(/* webpackChunkName: "privacy" */ '@/pages/privacy/statement')
    },
    {
      path: '/privacy_live',
      name: 'PrivacyLive',
      meta: { title: '直播服务协议' },
      component: () => import(/* webpackChunkName: "privacy" */ '@/pages/privacy/liveBroadcast')
    },
    {
      path: '/privacy_user',
      name: 'PrivacyUser',
      meta: { title: '用户服务协议' },
      component: () => import(/* webpackChunkName: "privacy" */ '@/pages/privacy/user')
    }
  ]
}

export default privacyRouter
